import { atom } from "jotai";

export const editAsTextDialogAtom = atom(false);
